<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card :header="$t('general.administrative.delays.title')" header-tag="h3" class="bg-default-card">
            <data-table
                v-if="tableLoaded"
                :exportable="false" title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @rowClickEdit="onEditRow"
                @rowClickDelete="onDeleteRow"
                @changePage="changePage"
                @searchEvent="searchEvent"
                @orderByEvent="orderByEvent"
                >
            </data-table>

            <b-dropdown id="dropdown-dropbottom" dropbottom :text="$t('general.buttons.return_to.title')" variant="primary" class="mt-3 mr-1" v-if="hasIsometricPermission || hasSpoolPermission || hasScaffoldingPermission || hasPunchlistPermission || hasPressureTestPermission || hasTieInPermission">
                <b-dropdown-item-btn @click="returnToIsometric" v-if="hasIsometricPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_isometric_management')}}
                </b-dropdown-item-btn>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-btn @click="returnToSpool" v-if="hasSpoolPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_spool')}}
                </b-dropdown-item-btn>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-btn @click="returnToScaffolding" v-if="hasScaffoldingPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_scaffolding')}}
                </b-dropdown-item-btn>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-btn @click="returnToPunchlist" v-if="hasPunchlistPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_punchlist')}}
                </b-dropdown-item-btn>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-btn @click="returnToPressureTest" v-if="hasPressureTestPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_pressure_test_planning')}}
                </b-dropdown-item-btn>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-btn @click="returnToTieIn" v-if="hasTieInPermission">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_tie_in')}}
                </b-dropdown-item-btn>
            </b-dropdown>

            <b-btn class="btn btn-default mt-3 mr-1" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_delays'], ['create'])"><i class="fa fa-plus-circle mr-1"></i>{{ $t('general.administrative.delays.create_button') }}</b-btn>
        </b-card>

        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_delays'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.disicipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.discipline"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.discipline != null && model.discipline.id != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDiscipline"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.discipline != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.drawing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.isometric"
                                :options="currentIsometric"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isIsometricLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="info" track-by="id"
                                :selectLabel="''"
                                @search-change="onIsometricSearch"
                                @input="updateIsometric"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.isometric != null && model.isometric.id != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedIsometric"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.discipline != null && model.discipline.id == 1 && model.isometric != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.spool') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.spool"
                                :options="currentSpool"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isSpoolLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="spool_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onSpoolSearch"
                                @input="updateSpool"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                         v-if="model.spool != null && model.spool.id != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedSpool"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.scaffolding') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.scaffolding"
                                :options="currentScaffolding"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isScaffoldingLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="request_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onScaffoldingSearch"
                                @input="updateScaffolding"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.scaffolding != null && model.scaffolding.id != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedScaffolding"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.punchlist') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.punchlist"
                                :options="currentPunchlist"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPunchlistLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="punch_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onPunchlistSearch"
                                @input="updatePunchlist"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.punchlist != null && model.punchlist.id != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPunchlist"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.pressure_test') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.pressure_test"
                                :options="currentPressureTest"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isPressureTestLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="test_circuit_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onPressureTestSearch"
                                @input="updatePressureTest"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.pressure_test != null && model.pressure_test.id != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedPressureTest"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.tie_in') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="model.tie_in"
                                :options="currentTieIn"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isTieInLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="tie_in_nr" track-by="id"
                                :selectLabel="''"
                                @search-change="onTieInSearch"
                                @input="updateTieIn"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.tie_in != null && model.tie_in.id != null"
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedTieIn"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.title') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.title">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.delay_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.delay_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.end_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.end_date"></flat-pickr>
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>

    <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
        {{ $t('messages.delete') }}
    </confirm-dialog>
</div>
</template>

<script>
    import Vue from 'vue';
    import http from '@/libs/http';
    import DataTable from '@/components/global/tables/datatables/DataTable.vue';
    import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
    import flatPickr from 'vue-flatpickr-component';
    import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
    import miniToastr from 'mini-toastr';
    import Multiselect from 'vue-multiselect';

    export default {
        name: 'delays',
        components: {
            DataTable,
            ConfirmDialog,
            flatPickr,
            Multiselect,
        },
        data () {
            return {
                breadcrumbItems: [
                    {
                        text: Vue.i18n.translate('general.dashboard.title'),
                        to: '/',
                    },
                    {
                        text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                        to: '/project/'+this.$route.params.id,
                    },
                    {
                        text: Vue.i18n.translate('general.administrative.title'),
                        active: true
                    },
                    {
                        text: Vue.i18n.translate('general.administrative.delays.title'),
                        active: true
                    }
                ],

                tableNameTranslated: Vue.i18n.translate('general.administrative.delays.title_modal'),
                tableName: 'delay',
                row: null,
                tableLoaded: false,
                perPage: 0,
                rowsCount: 0,
                currentPage: 1,
                pageCount: 1,
                sortType: 'asc',
                sortBy: 'id',
                searchInput: '',
                actionTitle: '',

                hasIsometricPermission: false,
                hasSpoolPermission: false,
                hasScaffoldingPermission: false,
                hasPunchlistPermission: false,
                hasPressureTestPermission: false,
                hasTieInPermission: false,

                currentDiscipline: [],
                isDisciplineLoading: false,

                currentIsometric: [],
                isIsometricLoading: false,

                currentScaffolding: [],
                isScaffoldingLoading: false,

                currentSpool: [],
                isSpoolLoading: false,

                currentPunchlist: [],
                isPunchlistLoading: false,

                currentPressureTest: [],
                isPressureTestLoading: false,

                currentTieIn: [],
                isTieInLoading: false,

                model: {
                    discipline_id: null,
                    discipline: null,

                    isometric_id: null,
                    isometric: null,

                    scaffolding_id: null,
                    scaffolding: null,

                    spool_id: null,
                    spool: null,

                    punchlist_id: null,
                    punchlist: null,

                    pressure_test_id: null,
                    pressure_test: null,

                    tie_in_id: null,
                    tie_in: null,

                    remarks: null,
                    title: null,
                    delay_date: null,
                    end_date: null,
                },
                getData: {
                    rowData: [],
                },
                columnData: [
                    {
                        label: Vue.i18n.translate('misc.actions'),
                        width: '90px',
                        field: '',
                        showDeleteButton: true,
                        showEditButton: true
                    },
                    {
                        label: Vue.i18n.translate('table.discipline'),
                        field: 'discipline.name',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.drawing'),
                        field: 'drawing.info',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.scaffolding'),
                        field: 'scaffolding.request_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.spool'),
                        field: 'spool.spool_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.punchlist'),
                        field: 'punchlist.title',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.pressure_test'),
                        field: 'pressure_test.test_circuit_no',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.tie_in'),
                        field: 'tie_in.tie_in_nr',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.title'),
                        width: '170px',
                        field: 'title',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.delay_date'),
                        width: '105px',
                        field: 'delay_date',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.end_date'),
                        width: '105px',
                        field: 'end_date',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.delay_active'),
                        width: '120px',
                        field: 'delay_active',
                        numeric: false,
                        html: false,
                        showAsCheckRed: true,
                        cursor: false
                    }
                ]
            }
        },
        mounted () {
            this.hasIsometricPermission    = this.$store.getters.hasPermission(['project_isometric'], ['read']);
            this.hasSpoolPermission        = this.$store.getters.hasPermission(['project_spool_management'], ['read']);
            this.hasScaffoldingPermission  = this.$store.getters.hasPermission(['project_scaffolding'], ['read']);
            this.hasPunchlistPermission    = this.$store.getters.hasPermission(['project_punch_list'], ['read']);
            this.hasPressureTestPermission = this.$store.getters.hasPermission(['project_pressure_test_planning'], ['read']);
            this.hasTieInPermission        = this.$store.getters.hasPermission(['project_tie_in'], ['read']);

            this.onLoadTable();
        },
        methods: {
            successMsg(msg) {
                miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
            },
            errorMsg(msg) {
                miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
            },
            warnMsg(msg) {
                miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 10000);
            },
            orderByEvent (column, sort_type) {
                this.sortType = sort_type;
                this.sortBy = column.field;
                this.onLoadTable();
            },
            searchEvent (searchInput) {
                this.searchInput = searchInput;
                this.onLoadTable();
            },
            changePage (page) {
                this.currentPage = page;
                this.onLoadTable();
            },
            onLoadTable () {
                let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
                data.then(response => {
                    if (!response.isError) {
                        this.perPage     = response.pagination.limit;
                        this.rowsCount   = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount   = response.pagination.totalPages;
                        var data = response.data;

                        data.forEach(field => {
                            if((field.discipline == null || field.discipline == '')) {
                                field.discipline = {'id': null, 'name': '' };
                            }

                            if((field.drawing == null || field.drawing == '')) {
                                field.drawing = { 'id': null, 'info': '' };
                            }

                            if((field.scaffolding == null || field.scaffolding == '')) {
                                field.scaffolding = { 'id': null, 'request_no': '' };
                            }

                            if((field.spool == null || field.spool == '')) {
                                field.spool = { 'id': null, 'spool_no': '' };
                            }

                            if((field.punchlist == null || field.punchlist == '')) {
                                field.punchlist = { 'id': null, area: '' };
                            }

                            if((field.pressure_test == null || field.pressure_test == '')) {
                                field.pressure_test = { 'id': null, 'test_circuit_no': '' };
                            }

                            if((field.tie_in == null || field.tie_in == '')) {
                                field.tie_in = { 'id': null, 'tie_in_nr': '' };
                            }
                        });
                        this.getData.rowData = data;
                        this.tableLoaded = true;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            },
            onAddRow () {
                this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
                this.row = null;
                this.model.discipline_id    = null;
                this.model.isometric_id     = null;
                this.model.scaffolding_id   = null;
                this.model.spool_id         = null;
                this.model.punchlist_id     = null;
                this.model.pressure_test_id = null;
                this.model.tie_in_id        = null;
                this.model.remarks          = null;
                this.model.title            = null;
                this.model.delay_date       = null;
                this.model.end_date         = null;

                this.currentDiscipline   = [];
                this.currentIsometric    = [];
                this.currentScaffolding  = [];
                this.currentSpool        = [];
                this.currentPunchlist    = [];
                this.currentPressureTest = [];
                this.currentTieIn        = [];

                this.model.discipline    = null;
                this.model.isometric     = null;
                this.model.scaffolding   = null;
                this.model.spool         = null;
                this.model.punchlist     = null;
                this.model.pressure_test = null;
                this.model.tie_in        = null;

                this.$refs.saveModal.show();
            },
            onEditRow (row) {
                this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
                this.row = row;
                this.model.discipline_id = this.row.discipline_id;
                this.model.isometric_id  = this.row.isometric_id;
                this.model.remarks       = this.row.remarks;
                this.model.title         = this.row.title;
                this.model.delay_date    = this.row.delay_date;
                this.model.end_date      = this.row.end_date;

                this.model.discipline    = this.row.discipline;
                this.model.isometric     = this.row.drawing;
                this.model.scaffolding   = this.row.scaffolding;
                this.model.spool         = this.row.spool;
                this.model.punchlist     = this.row.punchlist;
                this.model.pressure_test = this.row.pressure_test;
                this.model.tie_in        = this.row.tie_in;

                this.$refs.saveModal.show();
            },
            onDeleteRow (row, index) {
                this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
                this.row = row;
                this.$refs.deleteModal.show();
            },
            saveAction (e) {
                if (this.model.isometric == null) {
                    this.model.isometric = {'id': null}
                }

                if (new Date(this.model.end_date) <= new Date() && new Date(this.model.end_date) > new Date(this.model.delay_date)) {
                    this.warnMsg(Vue.i18n.translate('messages.end_date'));
                }

                e.preventDefault();
                let put_data = {
                    title:            this.model.title,
                    project_id:       this.$route.params.id,
                    discipline_id:    (this.model.discipline != null) ? this.model.discipline.id : null,
                    isometric_id:     (this.model.isometric != null) ? this.model.isometric.id : null,
                    scaffolding_id:   (this.model.scaffolding != null) ? this.model.scaffolding.id : null,
                    spool_id:         (this.model.spool != null) ? this.model.spool.id : null,
                    punchlist_id:     (this.model.punchlist != null) ? this.model.punchlist.id : null,
                    pressure_test_id: (this.model.pressure_test != null) ? this.model.pressure_test.id : null,
                    tie_in_id:        (this.model.tie_in != null) ? this.model.tie_in.id : null,
                    remarks:          this.model.remarks,
                    delay_date:       this.model.delay_date,
                    end_date:         this.model.end_date,
                }

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                if (this.row) {
                    let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                    data.then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.$refs.saveModal.hide();
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        }
                    });
                } else {
                    let data = http.route(this.tableName).post(put_data, true);
                    data.then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.$refs.saveModal.hide();
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        }
                    });
                }
            },
            deleteAction (button) {
                if (button == 1) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
                this.$refs.deleteModal.hide();
            },
            returnToIsometric () {
                this.$router.push({name: 'isometric_management'});
            },
            returnToScaffolding () {
                this.$router.push({name: 'scaffolding'});
            },
            returnToSpool () {
                this.$router.push({name: 'spool_management'});
            },
            returnToPunchlist () {
                this.$router.push({name: 'punchlist'});
            },
            returnToPressureTest () {
                this.$router.push({name: 'pressure_test_planning'});
            },
            returnToTieIn () {
                this.$router.push({name: 'tie_in_management'});
            },
            onDisciplineSearch(search) {
                if (search == '') {
                    this.currentDiscipline = [];
                    
                    return false;
                }

                this.isDisciplineLoading = true;
                this.searchDiscipline(search, this);
            },
            searchDiscipline: _.debounce((search, vm) => {
                let data = http.route('discipline?project_id=' + vm.$route.params.id + '&search_select=' + search + '&ids[]=1&ids[]=2&ids[]=3&ids[]=4&ids[]=5&ids[]=6').get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentDiscipline = response.data;
                    }
                    vm.isDisciplineLoading = false;
                });
            }, 500),
            updateDiscipline(discipline) {
                this.model.isometric = null;
                this.currentIsometric = [];
                if (discipline == null) {
                    this.model.discipline = {'id': null};
                } else {
                    http.route('drawing?project_id=' + this.$route.params.id + '&filters[parent_drawing_id]=null&filters[discipline_id]='+discipline.id).get().then(response => {
                        if(response.data != false) {
                            this.currentIsometric = response.data;
                        }
                    });
                }
            },
            clearSelectedDiscipline () {
                this.model.discipline    = {'id': null};
                this.model.discipline_id = null;
            },
            onIsometricSearch(search) {
                if (search == '') {
                    this.currentIsometric = [];
                    
                    return false;
                }

                this.isIsometricLoading = true;
                this.searchIsometric(search, this);
            },
            searchIsometric: _.debounce((search, vm) => {
                if (vm.model.discipline.id != null) {
                    let data = http.route('drawing?project_id=' + vm.$route.params.id + '&get_all=1&filters[discipline_id]='+vm.model.discipline.id+'&search_select=' + search + '&filters[parent_drawing_id]=null').get();
                    data.then(response => {
                        if (response.data != false) {
                            vm.currentIsometric = response.data;
                        }
                        vm.isIsometricLoading = false;
                    });
                } else {
                    vm.isDisciplineLoading = false;
                    return false;
                }
            }, 500),
            updateIsometric(drawing) {
                if(drawing == null) {
                    this.model.isometric = {'id': null};
                } else {
                    http.route('spool?project_id='+this.$route.params.id+'&filters[drawing_id]=' + drawing.id).get().then(response => {
                        if (response.data != false) {
                            this.currentSpool = response.data;
                        }
                    });
                }

                this.model.isometric_id = (drawing != null) ? drawing.id : null;
            },
            clearSelectedIsometric () {
                this.model.isometric    = {'id': null};
                this.model.isometric_id = null;
            },
            onScaffoldingSearch(search) {
                if (search == '') {
                    this.currentScaffolding = [];
                    
                    return false;
                }

                this.isScaffoldingLoading = true;
                this.searchScaffolding(search, this);
            },
            searchScaffolding: _.debounce((search, vm) => {
                let data = http.route('scaffolding?project_id=' + vm.$route.params.id + '&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentScaffolding = response.data;
                    }
                    vm.isScaffoldingLoading = false;
                });
            }, 500),
            updateScaffolding(scaffolding) {
                if(scaffolding == null) {
                    this.model.scaffolding = {'id': null};
                }

                // this.model.scaffolding_id = (scaffolding != null) ? scaffolding.id : null;
            },
            clearSelectedScaffolding () {
                this.model.scaffolding    = {'id': null};
                this.model.scaffolding_id = null;
            },
            onSpoolSearch(search) {
                if (search == '') {
                    this.currentSpool = [];
                    
                    return false;
                }

                this.isSpoolLoading = true;
                this.searchSpool(search, this);
            },
            searchSpool: _.debounce((search, vm) => {
                let data = http.route('spool?project_id=' + vm.$route.params.id + '&filters[drawing_id]='+vm.model.isometric_id+'&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentSpool = response.data;
                    }
                    vm.isSpoolLoading = false;
                });
            }, 500),
            updateSpool(spool) {
                if (spool == null) {
                    this.model.spool = {'id': null};
                }

                // this.model.spool_id = (spool != null) ? spool.id : null;
            },
            clearSelectedSpool () {
                this.model.spool    = {'id': null};
                this.model.spool_id = null;
            },
            onPunchlistSearch(search) {
                if (search == '') {
                    this.currentPunchlist = [];
                    
                    return false;
                }

                this.isPunchlistLoading = true;
                this.searchPunchlist(search, this);
            },
            searchPunchlist: _.debounce((search, vm) => {
                let data = http.route('punchlist?project_id=' + vm.$route.params.id + '&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentPunchlist = response.data;
                    }
                    vm.isPunchlistLoading = false;
                });
            }, 500),
            updatePunchlist(punchlist) {
                if(punchlist == null) {
                    this.model.punchlist = {'id': null};
                }

                // this.model.punchlist_id = (punchlist != null) ? punchlist.id : null;
            },
            clearSelectedPunchlist () {
                this.model.punchlist    = {'id': null};
                this.model.punchlist_id = null;
            },
            onPressureTestSearch(search) {
                if (search == '') {
                    this.currentPressureTest = [];
                    
                    return false;
                }

                this.isPressureTestLoading = true;
                this.searchPressureTest(search, this);
            },
            searchPressureTest: _.debounce((search, vm) => {
                let data = http.route('pressuretest?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_pressure_test_id]=null').get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentPressureTest = response.data;
                    }
                    vm.isPressureTestLoading = false;
                });
            }, 500),
            updatePressureTest(pressureTest) {
                if (pressureTest == null) {
                    this.model.pressure_test = {'id': null};
                }

                // this.model.pressure_test_id = (pressureTest != null) ? pressureTest.id : null;
            },
            clearSelectedPressureTest () {
                this.model.pressure_test    = {'id': null};
                this.model.pressure_test_id = null;
            },
            onTieInSearch(search) {
                if (search == '') {
                    this.currentTieIn = [];
                    
                    return false;
                }

                this.isTieInLoading = true;
                this.searchTieIn(search, this);
            },
            searchTieIn: _.debounce((search, vm) => {
                let data = http.route('tie_in?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_tie_in_id]=null').get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentTieIn = response.data;
                    }
                    vm.isTieInLoading = false;
                });
            }, 500),
            updateTieIn(tieIn) {
                if (tieIn == null) {
                    this.model.tie_in = {'id': null};
                }
                // this.model.tie_in_id = (tieIn != null) ? tieIn.id : null;
            },
            clearSelectedTieIn () {
                this.model.tie_in    = {'id': null};
                this.model.tie_in_id = null;
            },
        }
    }
</script>

<style scoped>
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/project/administrative/delays/delays.vue